module.exports = __webpack_public_path__ + "static/media/lawlogo.a23ab867.png";